export default {
	root: {
		fontFamily: 'Prompt',
		backgroundColor: 'rgba(255, 255, 255, 0.09)',
	}
};
